var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61823 12.6333C2.20712 12.6333 1.85156 12.4862 1.55156 12.1919C1.25156 11.8973 1.10156 11.5388 1.10156 11.1166V2.54993H0.351562V1.03327H3.90156V0.266602H8.0849V1.03327H11.6516V2.54993H10.9016V11.1166C10.9016 11.5388 10.7516 11.8973 10.4516 12.1919C10.1516 12.4862 9.79601 12.6333 9.3849 12.6333H2.61823ZM9.3849 2.54993H2.61823V11.1166H9.3849V2.54993ZM3.9349 9.83327H5.35156V3.83327H3.9349V9.83327ZM6.65156 9.83327H8.06823V3.83327H6.65156V9.83327Z",
    fill: "#4E5FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.873667773ef0e105952c120435b678fe.svg";
export { ForwardRef as ReactComponent };